var Vector = (function () {
    function Vector(type) {
        this.content = {};
        this.content.type = type;
    }
    Object.defineProperty(Vector.prototype, "end", {
        get: function () {
            return this.content;
        },
        enumerable: true,
        configurable: true
    });
    Vector.prototype.color = function (color) {
        this.content.color = color;
        return this;
    };
    Vector.prototype.lineColor = function (lineColor) {
        this.content.lineColor = lineColor;
        return this;
    };
    Vector.prototype.lineWidth = function (lineWidth) {
        this.content.lineWidth = lineWidth;
        return this;
    };
    Vector.prototype.lineCap = function (type) {
        this.content.lineCap = type;
        return this;
    };
    Vector.prototype.fillOpacity = function (fillOpacity) {
        this.content.fillOpacity = fillOpacity;
        return this;
    };
    Vector.prototype.linearGradient = function (linearGradient) {
        this.content.linearGradient = linearGradient;
        return this;
    };
    Vector.prototype.dash = function (length) {
        this.content.dash = { length: length };
        return this;
    };
    return Vector;
}());
export { Vector };
